module.exports = __webpack_public_path__ + "img/logo.ecad01df.svg";